import { CheckCircleIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Image,
  Link,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { BigNumber, ContractTransaction } from 'ethers';
import { NextSeo } from 'next-seo';
import NextLink from 'next/link';
import { useEffect, useState } from 'react';
import PFPBuilder from '../components/PFPBuilder';
import Footer from '../components/Footer';
import TransactionWaitModal from '../components/modals/TransactionWaitModal';
import SameTraits from '../components/SameTraits';
import { SongADay__factory } from '../types';
import { PUBLIC_MINT_SUPPLY, SONGADAY_CONTRACT_ADDRESS } from '../utils/constants';
import { validateBeforeWriting } from '../utils/helpers';
import { parseErrorMessage } from '../web3/helpers';
import { useContract, useReadContract, useWriteContract } from '../web3/hooks';
import { useWallet } from '../web3/WalletContext';

export default function MintPFP() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const songCost = 0.2;
  const toast = useToast();

  const contractAddress = SONGADAY_CONTRACT_ADDRESS;
  const { contract } = useContract(contractAddress, SongADay__factory, { useStaticProvider: true });
  const [txHash, setTxHash] = useState<string | undefined>();
  const [mintAmount, setMintAmount] = useState(1);
  const { connectWallet, address, chainId, isConnected } = useWallet();
  const { response: priceAmount } = useReadContract(contract, 'priceAmount');
  // const { response: totalRemaining } = useReadContract(contract, 'totalRemaining', {
  //   autoUpdate: true,
  // });
  const totalRemaining = BigNumber.from(0);
  const maxMint = totalRemaining?.lte(5) ? totalRemaining?.toNumber() : 5;

  // Update the mint amount if the total remaining changes.
  useEffect(() => {
    if (maxMint < mintAmount) {
      setMintAmount(maxMint);
    }
  }, [totalRemaining]);

  const handleConfirmation = async () => {
    toast({
      status: 'success',
      title: 'Minted',
      description: 'Your song(s) will be available on the my songs page in a few minutes.',
    });
    onClose();
  };

  const handleMint = async (response: ContractTransaction) => {
    setTxHash(response.hash);
    console.log('Waiting for transaction to finish');
  };

  const handleError = (error: any) => {
    toast({
      status: 'error',
      title: 'Error',
      description: parseErrorMessage(error),
    });
    onClose();
    console.log(error);
  };

  const [mint] = useWriteContract(contract, 'publicMint', {
    onConfirmation: handleConfirmation,
    onError: handleError,
    onResponse: handleMint,
  });

  const SongNotes = (props) => {
    const notes = new Array(maxMint).fill('🎙');
    return (
      <>
        <HStack py={8} {...props}>
          {notes.map((note, index) => {
            return (
              <Text key={index} fontSize={36} opacity={index < mintAmount ? '1' : '.2'}>
                {note}
              </Text>
            );
          })}
        </HStack>
      </>
    );
  };

  return (
    <>
      <NextSeo
        description="Mint random songs from the Song A Day catalog!"
        title="Mint | Song a Day World"
        twitter={{
          cardType: 'summary_large_image',
          handle: '@songadaymann',
          site: 'Song a Day World',
        }}
        openGraph={{
          images: [{ url: 'https://songaday.world/assets/music-rainbow.png' }],
        }}
      />

      <Box bgGradient="linear(to-b, brand.lightTeal, transparent)">
        <Container py={16} maxWidth="container.xl">
          <Stack spacing={4}>
            {/* <Heading>The Composition of A S.A.D NFT</Heading> */}
            <PFPBuilder></PFPBuilder>
          </Stack>
        </Container>
      </Box>

      {/* <Footer /> */}
      {/* <TransactionWaitModal isOpen={isOpen} onClose={onClose} txHash={txHash} /> */}
    </>
  );
}
